<template>
  <div class="flex-1 relative mb-[5rem]">
    <slot />
  </div>
</template>
